import { useSelector } from "react-redux";
import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { ImagePreview } from "../FormElements";
import ImageUploader from "../../ImageUploader";

export const GraphicEditor = ({ cue, media, onUpdate, encode = true }) => {
	const cloud = useSelector((state) => state.rundown.cloud) || false;
	return (
		<>
			<H2RInput
				label="Message"
				value={cue.body}
				onChange={(value) => {
					onUpdate({ body: value });
				}}
			/>
			<H2RSelect
				selected={cue.backgroundFit || "cover"}
				label="Image size"
				options={[
					{
						label: "Grow to fill screen",
						value: "cover",
					},
					{
						label: "Shrink to fit",
						value: "contain",
					},
				]}
				onChange={(value) => {
					return onUpdate({ backgroundFit: value });
				}}
			/>

			{cloud ? (
				<H2RInput
					label="Image URL"
					value={cue.url}
					placeholder={`https://media.h2r.graphics/image.png`}
					onChange={(change) => {
						onUpdate({ url: change });
					}}
				/>
			) : (
				<H2RSelect
					selected={cue.filename}
					label="Image"
					options={
						media.length === 0
							? [
									{
										label: "Add images in the Media tab",
										value: ``,
										disabled: true,
									},
							  ]
							: [
									...media
										.filter((item) => item.mimetype.includes("image"))
										.filter((item) => !item.partOf)
										.sort((a, b) => {
											if(a.originalname.toUpperCase() < b.originalname.toUpperCase()) { return -1; }
											if(a.originalname.toUpperCase() > b.originalname.toUpperCase()) { return 1; }
											return 0;
										})
										.map((item) => {
											return {
												label: item.originalname,
												value: item.filename,
											};
										}),
							  ]
					}
					onChange={(value) => {
						return onUpdate({ filename: value });
					}}
				/>
			)}
			{cloud ? 
				<ImageUploader cue={cue} onUpdate={(url)=>onUpdate({url})} />
			:
				<ImagePreview image={cue.filename} />
			}
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.body || ""}</span>
		</div>
	);
};
